module.exports = __webpack_public_path__ + "static/media/dwellPass-emblem-map-yellow-shadow-120.97657656.png";